var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var ZoomIn = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18.8549958,18.8540978 C18.6597244,19.0493692 18.3431348,19.0493948 18.1478318,18.8541551 L15.7291059,16.4362127 C14.5923385,17.4110487 13.1149477,18 11.5,18 C7.91014913,18 5,15.0898509 5,11.5 C5,7.91014913 7.91014913,5 11.5,5 C15.0898509,5 18,7.91014913 18,11.5 C18,13.1149477 17.4110487,14.5923385 16.4362127,15.7291059 L18.8549386,18.1470483 C19.0502007,18.3422472 19.050252,18.6587784 18.8550531,18.8540405 L18.8549958,18.8540978 Z M11.5,17 C14.5375661,17 17,14.5375661 17,11.5 C17,8.46243388 14.5375661,6 11.5,6 C8.46243388,6 6,8.46243388 6,11.5 C6,14.5375661 8.46243388,17 11.5,17 Z M12,11 L14,11 L14,12 L12,12 L12,14 L11,14 L11,12 L9,12 L9,11 L11,11 L11,9 L12,9 L12,11 Z" })));
};
ZoomIn.displayName = 'ZoomIn';
export default ZoomIn;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ZoomIn.js.map